import { ReactElement } from 'react';
import { SvgIconComponent } from '@mui/icons-material';
import { Box, Tooltip, Typography } from '@mui/material';
import AccessTimeOutlinedIcon from '@mui/icons-material/AccessTimeOutlined';
import EngineeringOutlinedIcon from '@mui/icons-material/EngineeringOutlined';
import AssignmentOutlinedIcon from '@mui/icons-material/AssignmentOutlined';
import FactCheckOutlinedIcon from '@mui/icons-material/FactCheckOutlined';

interface SrtStatusConfig {
    label: string;
    color: string;
    Icon: SvgIconComponent;
}

const SRT_STATUS_ICON_CONFIG: Record<number, SrtStatusConfig> = {
    1: { label: 'Pendiente', color: '#757575', Icon: AccessTimeOutlinedIcon },
    2: { label: 'En proceso — Preventor', color: '#E65100', Icon: EngineeringOutlinedIcon },
    3: { label: 'Cargado', color: '#0D47A1', Icon: AssignmentOutlinedIcon },
    4: { label: 'Exportado', color: '#1B5E20', Icon: FactCheckOutlinedIcon }
};

interface SrtStatusIconProps {
    estadoSrt?: number;
}

const SrtStatusIcon = ({ estadoSrt }: SrtStatusIconProps): ReactElement => {
    const config = estadoSrt ? SRT_STATUS_ICON_CONFIG[estadoSrt] : undefined;

    if (!config) {
        return (
            <Box display="flex" justifyContent="center">
                <Typography variant="body2">-</Typography>
            </Box>
        );
    }

    const { label, color, Icon } = config;

    return (
        <Box display="flex" justifyContent="center">
            <Tooltip title={label} arrow>
                <Icon aria-label={label} sx={{ color }} fontSize="medium" />
            </Tooltip>
        </Box>
    );
};

export default SrtStatusIcon;
